import store from "../store";
import router from "../router";
import { FirebaseApp } from "../auth";

class AuthService {

  getUser() {
    return FirebaseApp.auth().currentUser;
  }

  getNewToken(): Promise<string> | undefined {
    return FirebaseApp.auth().currentUser?.getIdToken(true);
  }

  logout() {
    FirebaseApp.auth()
      .signOut()
      .then(() => {
        router.replace("/login");
        store.commit("resetState");
        localStorage.removeItem('token');
      })
      .catch(function (error) {
        console.log(error);
      });
  }
}

export default new AuthService();